'use strict'

function init() {
	$('.employees').on('click', '.employee', function() {
		if ($(this).hasClass('employee--active')) {
			cleanup();
		} else {
			cleanup();
			activate($(this));
		}

	});
	$(window).resize(function() {
		cleanup();
	});
	function cleanup() {
		$('.employee').removeClass('employee--active');
		$('.employeeRow__detail').remove();
	}
	function activate(element) {
		insertDetail(element);
		element.addClass('employee--active');
		element.find('.employee__leftColumn, .employee__bio').clone().prependTo('.employeeRow__detail');
		$('.employeeRow__detail--close').on('click', function() {
			cleanup();
		});
	}
	function insertDetail(element) {
		var detailRow = '<div class="employeeRow__detail"><a class="employeeRow__detail--close">close</a></div>';
		var result = element.nextAll('.employee')
		.filter(function() {
			var elOffset = element.offset();
			var thisOffset = $(this).offset();
			return thisOffset.top > elOffset.top;
		}).first();
		if (result.length) {
			return result.before(detailRow);
		} else {
			return $(element).parent().find($('.employee:last-of-type')).after(detailRow);
		}
	}
}


var EmployeeBox = {
	init: init
};

module.exports = EmployeeBox;